import {
  CreativeListRecord,
  CreativeOfCampaign,
  CreativeType,
  isOneForAllCreativeType
} from 'core/creative/Creative';
import { NativeCreativeImagePreview } from './NativeCreativeImagePreview';
import { VideoCreativePreview } from './VideoCreativePreview';
import { NormalCreativePreview } from './NormalCreativePreview';
import { PPSCreativePreview } from './PPSCreativePreview';
import { HTML5CreativePreview } from './HTML5CreativePreview';
import { OutdoorCreativePreview } from './OutdoorCreativePreview';
import { UnavailablePreview } from 'components/UnavailablePreview/UnavailablePreview';
import { CustomCreativePreview } from './CustomCreativePreview';

const previewComponentSettings = {
  [CreativeType.NATIVE]: NativeCreativeImagePreview,
  [CreativeType.VIDEO]: VideoCreativePreview,
  [CreativeType.IMAGE]: NormalCreativePreview,
  [CreativeType.HTML5]: HTML5CreativePreview,
  [CreativeType.THIRD_PARTY]: PPSCreativePreview,
  [CreativeType.COMBO]: OutdoorCreativePreview,
  [CreativeType.EDIMAX]: OutdoorCreativePreview,
  [CreativeType.PIC_LONG]: OutdoorCreativePreview,
  [CreativeType.PIC_SHORT]: OutdoorCreativePreview,
  [CreativeType.PIC_EXTENDED]: OutdoorCreativePreview,
  [CreativeType.PIC_BROAD]: OutdoorCreativePreview,
  [CreativeType.CTV]: VideoCreativePreview,
  [CreativeType.CUSTOM_RECTANGLE]: PPSCreativePreview,
  [CreativeType.CUSTOM_BOTTOM]: PPSCreativePreview,
  [CreativeType.SANDBOX_OUTDOOR]: OutdoorCreativePreview,
  [CreativeType.FRIDGE_LONG]: OutdoorCreativePreview,
  [CreativeType.FRIDGE_EXTENDED]: OutdoorCreativePreview,
  [CreativeType.FRIDGE_BROAD]: OutdoorCreativePreview,
  [CreativeType.OUTDOOR_LINE_MESSAGE]: OutdoorCreativePreview,
  [CreativeType.LINE_MESSAGE]: OutdoorCreativePreview,
  [CreativeType.HWACOM_SHORT]: OutdoorCreativePreview,
  [CreativeType.HWACOM_LONG]: OutdoorCreativePreview,
  [CreativeType.HWACOM_EXTENDED]: OutdoorCreativePreview,
  [CreativeType.HWACOM_BROAD]: OutdoorCreativePreview
};

export interface CreativePreviewModel {
  creative: CreativeOfCampaign | CreativeListRecord;
  previewComponent: any;
}

export type CreativePreviewProps = {
  model: CreativePreviewModel;
};

export class DefaultCreativePreviewModel implements CreativePreviewModel {
  creative: CreativeOfCampaign | CreativeListRecord;
  previewComponent: any;

  constructor(creative: CreativeOfCampaign | CreativeListRecord) {
    this.creative = creative;
    if (!this.creative.creativeType) {
      this.previewComponent = CustomCreativePreview;
    } else if (isOneForAllCreativeType(this.creative.creativeType)) {
      this.previewComponent = UnavailablePreview;
    } else {
      this.previewComponent =
        previewComponentSettings[this.creative.creativeType] ||
        OutdoorCreativePreview;
    }
  }
}
